import ToolInsertEmbed from './tools/ToolInsertEmbed';
import { type EditorPlugin } from '../../types/aha-editor';
import { type Editor } from 'slate';
import isUrl from 'is-url';
import { wrapLink } from '../LinkPlugin/utils';
import History from '../../collaboration/History';
import { Transforms } from 'slate';
import EmbedCommon from './EmbedCommon';
import { isLinkElement } from '../../types/guards';

// Paste or drop for embeds.
const EmbedPastePlugin: EditorPlugin = {
  name: 'Embed paste plugin',
  insertData: (editor: Editor, data: DataTransfer) => {
    let text = data.getData('text/plain');
    if (!text) return false;

    text = text.trim();

    if (isUrl(text) && EmbedCommon.embedTypeForUrl(text)) {
      // Insert as a link first, so if the users choose Undo we switch back to
      // a plain link.
      History.withoutUndoMerging(editor, (editor) => {
        wrapLink(editor, text, text);
      });

      // Remove the link we just inserted and replace with the embed.
      Transforms.removeNodes(editor, { match: isLinkElement });
      ToolInsertEmbed.insertEmbed(editor, text);

      return true;
    } else {
      return false;
    }
  },
};

export default EmbedPastePlugin;
